import { IGif } from '@giphy/js-types'
import { createContext, SyntheticEvent } from 'react'
import { AppConfig } from './constants'

export type SearchMode = 'stickers' | 'gifs' | 'emoji' | 'text' | 'videos'

export type MessageId = 'giphyText' | 'emojiVariations'

type ContextValue = {
    apiKey: string
    onCloseClick?: () => void
    isFetching: boolean
    setIsFetching: (isFetching: boolean) => void
    onGifClick: (gif: IGif, e: SyntheticEvent<HTMLElement, Event>) => void
    displayGif: IGif | undefined
    setDisplayGif: (gif: IGif | undefined) => void
    setSearchMode: (mode: SearchMode) => void
    setVideoMuted: (muted: boolean) => void
    searchMode: SearchMode
    videoMuted: boolean
    config: AppConfig
    savedTrendingState: string[][]
    setSavedTrendingState: (savedTrendingState: string[][]) => void
    savedTrendingSearchTerms: string[]
    setSavedTrendingSearchTerms: (trendingSearchTerms: string[]) => void
    hardCodedCategories: string[]
    categories: string[]
    setSeenMessage: (id: MessageId, seen: boolean) => void
    seenMessage: (id: MessageId) => boolean
    setSeenOnboard: (seen: boolean) => void
    seenOnboard: boolean
}

export const AppContext = createContext<ContextValue>({} as ContextValue)
